import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "../pages/landing/LandingPage";
import Register from "../pages/auth/Register";
import Login from "../pages/auth/Login";
import ForgotPasswordPage from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import NotFound from "../pages/NotFound";
import TOS from "../pages/TOS/TOS";
import DashboardLayout from "../pages/dashboard/DashboardLayout";
import SetTheme from "../pages/dashboard/SetTheme/SetTheme";
import Packet from "../pages/dashboard/Packet";
import ContactUs from "../pages/dashboard/ContactUs";
import Profile from "../pages/dashboard/Profile";
import Logout from "../pages/dashboard/Logout";
import ProtectedRoute from "./ProtectedRoute";
import ThemeDetail from "../pages/landing/themes/ThemesDetailsSection";
import PersonalInformationForm from "../pages/dashboard/SetTheme/PersonalInformationForm";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/terms-of-service" element={<TOS />} />
      <Route path="/themes-detail" element={<ThemeDetail />} />
      <Route path="/personal-information" element={<PersonalInformationForm />} />
      <Route path="/set-theme" element={<SetTheme />} />


      {/* Protected Dashboard Routes */}
      <Route path="/dashboard" element={<ProtectedRoute />}>
        <Route path="" element={<DashboardLayout />}>
          <Route path="set-theme" element={<SetTheme />} />
          <Route path="packet" element={<Packet />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="profile" element={<Profile />} />
          <Route path="logout" element={<Logout />} />
        </Route>
      </Route>

      {/* Not Found Page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
